module.exports = __webpack_public_path__ + "img/support-2.0ddf137a.png";